import React, { useCallback } from 'react';

import { FlexColumn, Gap } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { messages } from './messages';
import { SimpleModal } from '../../../../../../components/simple-modal/simple-modal';
import { formatAddress } from '../../../../../products-page/purchase-orders/address-helpers';

/** @typedef {import('../../types').BlacklistEntry} BlacklistEntry */

/**
 * @param {object} props
 * @param {BlacklistEntry} props.entry
 * @param {() => void} props.onClose
 * @param {(entryId: number) => void} props.onRemove
 * @param {boolean} [props.isRemoving]
 * @returns {JSX.Element}
 */
export const RemoveBlacklistEntryModal = ({ entry, onClose, onRemove, isRemoving = false }) => {
  const handleRemove = useCallback(() => {
    onRemove(entry.id);
  }, [onRemove, entry.id]);

  return (
    <SimpleModal
      actionButtonDataPendoId
      actionButtonTheme={THEME_CONSTANTS.danger}
      actionMessage={messages.remove}
      cancelMessage={messages.cancel}
      data-testid='remove-blacklist-entry-modal'
      headerMessage={messages.header}
      isActionDisabled={isRemoving}
      onAction={handleRemove}
      onCancel={onClose}
      onClose={onClose}
    >
      <FlexColumn gap={Gap.Space8}>
        <Text textType={TextType.Paragraph} value={messages.confirmMessage} />
        <span>{formatAddress(entry)}</span>
      </FlexColumn>
    </SimpleModal>
  );
};
